module.exports = __webpack_public_path__ + "img/en-las-redes.60702eeb.svg";